import { isArray } from "../utils/index.js";
function getDirectChildren(parentInstance, parentName, childrenName) {
  const children = parentInstance.$children[childrenName];
  const nestedParents = parentInstance.$children[parentName];
  if (!isArray(children)) {
    return [];
  }
  if (!isArray(nestedParents) || nestedParents.length <= 0) {
    return children;
  }
  return [...children].filter(
    (child) => [...nestedParents].every((nestedParent) => {
      const nestedChildren = nestedParent.$children[childrenName];
      return isArray(nestedChildren) ? !nestedChildren.includes(child) : true;
    })
  );
}
function isDirectChild(parentInstance, parentName, childrenName, childInstance) {
  return getDirectChildren(parentInstance, parentName, childrenName).includes(childInstance);
}
export {
  getDirectChildren,
  isDirectChild
};
//# sourceMappingURL=getDirectChildren.js.map
